<template>
	<div :class="['space', { mobile: isMobile }]">
		<section class="sec-1 active" ref="sec1">
			<div class="content">
				<h3 class="title textfade textfade1" v-html="text.first.title"></h3>
				<p class="text textfade textfade2" v-html="text.first.text"></p>
			</div>
      <div class="imgs" >
				<div class="blue"></div>
				<div class="blue"></div>
				<div class="blue"></div>
				<div class="blue" v-if="!isMobile"></div>
				<div class="yellow"></div>
				<div class="yellow"></div>
				<div class="yellow"></div>
				<div class="yellow"></div>
				<div class="yellow" v-if="!isMobile"></div>
				<div class="yellow" v-if="!isMobile"></div>
				<div class="yellow" v-if="!isMobile"></div>
				<div class="yellow" v-if="!isMobile"></div>
				<div class="yellow" v-if="!isMobile"></div>
				<div class="yellow" v-if="!isMobile"></div>
			</div>		  
			<div class="mac-video" v-if="!isMobile">
        <div class="video-wrap">
          <video
            :controls="false"
            :x5-video-player-fullscreen="true"
            controlslist="nodownload nofullscreen noremoteplayback"
            x5-video-player-type="h5"
            playsinline
            muted
            autoplay
            preload="metadata">
              <source src="/video/space.mp4" type="video/mp4">
            </video>
        </div> 
      </div>
			<div class="mac"></div> 
      <div class="mark"></div>
      <show-more @handleSecond="handleSecond"></show-more>
    </section>
		<section :class="['sec-3',{active:n> 1}]" ref="sec2">
			<div class="content">
				<h3 :class="['title textfade', {textfade1: n>1}]" v-html="text.second.title"></h3>
				<p
					:class="['text textfade', {textfade2: n>1}]"
					v-html="text.second.text"
				></p>
			</div>
			<div class="imgs" v-if="n>0">
				<img
					class="model"
					:src="
						isMobile
							? require('../assets/image/space/mobile/model-2.png')
							: require('../assets/image/space/model-2.png')
					"
					alt=""
					srcset=""
				/>
				<img
					class="nest-1"
					:src="
						isMobile
							? require('../assets/image/space/mobile/nest-1.png')
							: require('../assets/image/space/nest-1.png')
					"
					alt=""
				/>
				<img
					class="nest-2"
					:src="
						isMobile
							? require('../assets/image/space/mobile/nest-2.png')
							: require('../assets/image/space/nest-2.png')
					"
					alt=""
				/>
				<img
					class="uav-l"
          :src="isMobile? require('../assets/image/space/mobile/uav-l.png'):require('../assets/image/space/uav-l.png')"
					alt=""
				/>
				<img
					class="uav-r"
          :src="isMobile? require('../assets/image/space/mobile/uav-r.png'):require('../assets/image/space/uav-r.png')"
					alt=""
				/>
				<img
					class="light-l"
          :src="isMobile? require('../assets/image/space/mobile/light-l.png'):require('../assets/image/space/light-l.png')"
					alt=""
				/>
				<img
					class="light-r"
          :src="isMobile? require('../assets/image/space/mobile/light-r.png'):require('../assets/image/space/light-r.png')"
					alt=""
				/>
			</div>
		</section>
		<!-- <section :class="['sec-3',{active: n > 1}]" ref="sec3">
			<div class="content">
				<h3 :class="['title textfade', {textfade1: n>2}]" v-html="text.third.title"></h3>
				<p :class="['text textfade',{textfade2: n>2}]" v-html="text.third.text"></p>
			</div>
      
		</section> -->
		<section :class="['sec-4', {active: n>2}]" ref="sec3">
			<div class="content">
				<h3 :class="['title textfade', {textfade1: n>2}]" v-html="text.forth.title"></h3>
				<p :class="['text textfade', {textfade2:n>2}]" v-html="text.forth.text"></p>
			</div>
			<div class="imgs" v-if="n > 1">
				<img
					class="grid"
          :src="isMobile? require('../assets/image/space/mobile/grid-3.png'):require('../assets/image/space/grid-3.png')"
					alt=""
				/>
				<img
					class="city"
          :src="isMobile? require('../assets/image/space/mobile/city-3.png'):require('../assets/image/space/city-3.png')"
					alt=""
				/>
				<img
					class="model-l"
          :src="isMobile? require('../assets/image/space/mobile/model-left.png'):require('../assets/image/space/left-model.png')"
					alt=""
				/>
				<img
					class="model-t"
          :src="isMobile? require('../assets/image/space/mobile/model-top.png'):require('../assets/image/space/top-model.png')"
					alt=""
				/>
				<div class="chart">
					<img class="line" :src="isMobile ? require('../assets/image/space/mobile/horizon.png') : require('../assets/image/space/horizon.png')" alt="">
          <img class="table" :src="isMobile ? require('../assets/image/space/mobile/table.png') : require('../assets/image/space/table.png')" alt="">
          <img class="curve" :src="isMobile ? require('../assets/image/space/mobile/curve.png') : require('../assets/image/space/curve.png')" alt="">
					<canvas ref="ball" width="86px" height="90px"></canvas>
				</div>
			</div>
		</section>

		<foot></foot>
	</div>
</template>
<script>


import { isMobile } from '@/js/utils'
import { space } from '@/js/text'
import { mapState, mapMutations } from 'vuex'

export default {
	name: 'space',
	metaInfo: {
		meta: [
			{
				name: 'keywords',
				content:
					'城市建设监管系统, SaaS, 防务云, 地图更新系统, 三维城市底座, 数据分发, 数据孤岛，IoT, AI, 超算平台, 智慧城市, 智慧旅游, 智慧交通, 数字规划，数字孪生，城市大脑'
			},
			{
				name: 'description',
				content:
					'城市建设监管系统覆盖智慧综治、智慧城管、智慧市政、智慧交通，以巨量异构城市数据为核心资源，数字孪生城市为底座，实现对全市域空间全周期全要素管控，促进城市治理现代化升级。'
			}
		]
	},
	data() {
		return {
			paths: [
				{
					path: 'M1,485 C119,365.509004 212.5,438.003541 403,259.516991 C593.5,81.0304401 799.5,224.019665 955,309.513223 C1110.5,395.006781 1314.5,319.51247 1473,290.014693',
					y: -157,
					x: 0,
					context: null,
					frameId: 0
				},{
					path: 'M1389,343.903021 C1077.38276,83.5101094 696.239368,390.294861 439.142642,425.712288 C267.744825,449.323906 141.363944,443.67042 60,408.75183',
					x: -59,
					y: -228,
					context: null,
					frameId: 0
				},{
					path: 'M345,501 C529.599892,406.906094 683.182999,0 880.289659,0 C1077.39632,0 1123.92149,212.211788 1269,223.723277',
					x: -343,
					y: 25,
					context: null,
					frameId: 0
				},
				// mobile
				{
					path: 'M0.310261706,150.476928 C36.921143,113.403447 65.9306126,135.895726 125.035468,80.5181843 C184.140323,25.1406426 248.054234,69.5047237 296.29993,96.0301008 C344.545625,122.555478 407.839013,99.1324841 457.015493,89.9804534',
					x: -68,
					y: -50,
					context: null,
					frameId: 0
				},
				{
					path: 'M430.95351,106.699938 C334.270614,25.909989 216.016414,121.09355 136.249145,132.082221 C83.0709663,139.408002 43.8598186,137.653942 18.6157024,126.82004',
					x: -68,
					y: -70,
					context: null,
					frameId: 0
				},
				{
					path: 'M107.040289,155.441115 C164.314566,126.247379 211.965523,0 273.120172,0 C334.27482,0 348.709801,65.8411915 393.722105,69.4127656',
					x: -106,
					y: 9,
					context: null,
					frameId: 0
				}
			],
			ballPath: {
				path: 'M86.67957,2.40285 C77.87957,44.20285 76.77957,46.40285 30.57957,57.40285 C12.64187,61.67415 3.07957,91.50285 3.07957,91.50285',
				x: -2,
				y: -2,
				context: null,
				frameId: 0
			},
			isMobile: false,
			n: 0,
			h: {
				h1: 0,
				h2: 0,
				h3: 0,
				h4: 0
			}
		}
	},
	components: {
		Foot: () => import('@/components/footer.vue'),
    ShowMore: () => import("../components/common/ShowMore")
	},
	computed: {
		...mapState(['headerStyle']),
		text() {
			return this.$route.params.lang === 'CN' ? space.CN : space.EN
		}
	},
	methods: {
		...mapMutations(['setHeaderStyle']),
		customizePath(path, flag=true) { //flag ? paths : ballPath
			const pathElement = document.createElementNS('http://www.w3.org/2000/svg',"path"); 
			pathElement.setAttributeNS(null, 'd', path.path);
			const length = pathElement.getTotalLength();
			let step = 0;
			step = pathElement.getTotalLength()
			const animate = () => {
					const x = parseInt(pathElement.getPointAtLength(step % length).x);
					const y = parseInt(pathElement.getPointAtLength(step % length).y);
					drawCircle(x, y);
					step += !flag ? 1 : this.isMobile ? 1 : 3
					path.frameId = window.requestAnimationFrame(animate)
			}
			const drawCircle = (x, y) => {
				let r = this.isMobile ? 2.4 : 4
				path.context.clearRect(0, 0, 2048, 1080)
				path.context.beginPath()
				path.context.moveTo(0,0)
				if(flag) {
					path.context.arc(x + path.x, y + path.y, r, 0,  Math.PI * 2, true)
					path.context.fillStyle = '#fff'
					path.context.filter = `blur(${r-1}px)`				
					path.context.fill()
					path.context.closePath()
				}else {
					path.context.arc(x + path.x, y + path.y, 4, 0,  Math.PI * 2, true)
					path.context.fillStyle = 'rgb(255, 230, 78)'
					path.context.fill()
					path.context.closePath()
					path.context.beginPath()
					path.context.arc(x + path.x, y + path.y, 20, 0,  Math.PI * 2, true)
					path.context.fillStyle = 'rgba(255, 230, 78, 0.02)'
					path.context.fill()
					path.context.closePath()
				}
				
			}
			animate()
		},
		initCanvas() {			
			this.paths.forEach((p, i) => {
				switch(i) {
					case 0: 
						p.context = this.$refs.firstLine.getContext('2d')
						break;
					case 1: 
						p.context = this.$refs.secondLine.getContext('2d')
						break;
					case 2: 
						p.context = this.$refs.thirdLine.getContext('2d')
						break;
					case 3: 
						p.context = this.$refs.firstLine.getContext('2d')
						break;
					case 4: 
						p.context = this.$refs.secondLine.getContext('2d')
						break;
					case 5: 
						p.context = this.$refs.thirdLine.getContext('2d')
						break;
				}
				if(this.isMobile && i > 2) {
					this.customizePath(p)
				}else if(!this.isMobile && i < 3){
					this.customizePath(p)
				}				
			})					
		},
		scrollEvent(e) {
			let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
			let { h1, h2, h3 } = this.h
			// if(scrollTop > h1 * 0.6 && this.n < 2) {
			// 	this.n = 2;
      //   setTimeout(this.initCanvas, 1800)
			// 	// this.getHeight()
			// }
      if(scrollTop > h1 * 0.6 && this.n < 2) {
				this.n = 2;
				this.getHeight()
			}
			if(scrollTop > h1 + h2 * 0.4  && this.n < 3) {
				this.n = 3
        this.ballPath.context = this.$refs.ball.getContext('2d')
				this.customizePath(this.ballPath, false)
			}
			// if(scrollTop > h1 + h2 + h3 * 0.7 && this.n < 4) {
			// 	this.n = 4
			// 	this.ballPath.context = this.$refs.ball.getContext('2d')
			// 	this.customizePath(this.ballPath, false)
			// }
			// if(scrollTop > h1 + h2 + h3 + h4 * 0.6 && this.n < 5) {
			// 	this.n = 5
			// }
		},
		resize() {
			this.getHeight()
			if(this.n > 1) {
				this.$refs.sec3.classList.remove('active')
				this.$nextTick(() => {
					this.$refs.sec3.classList.add('active')
				})
			}
			
		},
		getHeight() {
			if(this.$refs.sec1 && this.$refs.sec2 && this.$refs.sec3 ) {
				let h1 = this.$refs.sec1.offsetHeight
				let h2 = this.$refs.sec2.offsetHeight
				let h3 = this.$refs.sec3.offsetHeight
				// let h4 = this.$refs.sec4.offsetHeight				
				this.h = {h1, h2, h3}
			}
			
		},
    handleSecond() {
			let h = this.$refs.sec1.offsetHeight
			let scrollTo = () => {
				let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
				if(scrollTop < h && h - scrollTop > 15) {
					document.documentElement.scrollTop = scrollTop + (h - scrollTop) * 0.15
					document.body.scrollTop = scrollTop + (h - scrollTop) * 0.15
					window.requestAnimationFrame(scrollTo)
				}else {
					document.documentElement.scrollTop = h
					document.body.scrollTop = h 
				}
			}
			scrollTo()
		},
	},
	mounted() {
		this.isMobile = window.innerWidth <= 600 || isMobile()
		this.setHeaderStyle({ headerStyle: 'light' })
		this.$nextTick(() => {
			this.getHeight()			
		})
		setTimeout(() => {
			this.n = 1
		}, 500)
		window.addEventListener('scroll', this.scrollEvent)
		window.addEventListener('resize', this.resize)
	},
	beforeDestroy() {
		this.paths.forEach(p => {
			window.cancelAnimationFrame(p.frameId)
		})
		window.cancelAnimationFrame(this.ballPath.frameId)
	}
}
</script>
<style lang="scss" scoped>
@import '../assets/css/space1.scss';
</style>
